export const environment = {
  production: false,
  APP_URL: localStorage.getItem('main_URL'),

};